import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { MinimalDevice } from '@rtkwlf/asset-data-service';
import { IconButton, Popover } from '@rtkwlf/fenrir-react';
import { faEllipsisV } from '@rtkwlf/pro-solid-svg-icons/faEllipsisV';
import { faRotate } from '@rtkwlf/pro-solid-svg-icons/faRotate';
import { useTranslation } from 'react-i18next';

import {
  DrawerType,
  useActionDrawer,
} from '@packages/components/action-drawer/action-drawer-context';
import type { GridRowSelectionModel } from '@packages/fenrir/components';
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@packages/fenrir/components';

import { buildAssetRescanData } from '../build-asset-rescan-data/build-asset-rescan-data';
import { RescanAssets } from '../rescan-assets/rescan-assets';

type EllipsisMenuProps = {
  assetData: Array<MinimalDevice>;
  setRowSelectionModel: (model: GridRowSelectionModel) => void;
};

export const EllipsisMenu: React.FC<EllipsisMenuProps> = ({
  assetData,
  setRowSelectionModel,
}) => {
  const { t } = useTranslation('ads', {
    keyPrefix: 'assetRescanCommon',
  });

  const { openDrawer } = useActionDrawer();

  const handleUpdateButtonClick = () => {
    openDrawer(
      <RescanAssets
        drawerData={buildAssetRescanData(assetData)}
        setRowSelectionModel={setRowSelectionModel}
      />,
      {
        drawerType: DrawerType.FULL_HEIGHT_DRAWER,
      },
    );
  };

  // #TODO: There is a ticket to move this component to a common component and remove it from here:
  // https://arcticwolf.atlassian.net/browse/MR-7381
  // This is a temporary solution lifted from Risk Management
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <IconButton aria-label="open grid menu" color="primary">
          <FontAwesomeIcon icon={faEllipsisV} />
        </IconButton>
      </Popover.Trigger>
      <Popover.Content
        side="bottom"
        align="end"
        aria-labelledby="settingsPopOver"
      >
        <List sx={{ p: 0 }}>
          <ListItem disablePadding>
            <ListItemButton onClick={handleUpdateButtonClick}>
              <ListItemIcon sx={{ minWidth: 16, mr: 1 }}>
                <FontAwesomeIcon
                  icon={faRotate}
                  color="var(--aw-palette-primary-main)"
                  aria-label="rotate"
                  size="sm"
                />
              </ListItemIcon>
              <ListItemText
                primary={t('rescanAsset')}
                slotProps={{
                  primary: {
                    sx: {
                      color: 'var(--aw-palette-primary-main)',
                      fontSize: '14px',
                    },
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
        </List>
      </Popover.Content>
    </Popover.Root>
  );
};
